// Copyright (c) 2021 WiseTime. All rights reserved.

import { Init } from "../../../app/rpc"
import { ListDaySummariesRequestSchema } from "../../../generated/wisetime/user/timeline/v4/timeline_pb"

export const prepareListDaySummaryRequest = (activeDate: string): Init<typeof ListDaySummariesRequestSchema> => ({
  startDate: activeDate,
  endDate: activeDate,
})
